import _objectSpread from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { TextEvent } from './TextEvent';

var debug = require('debug')('CRATE:Communication:TextManager:RemoveManager');

export var RemoveManager =
/*#__PURE__*/
function (_TextEvent) {
  _inherits(RemoveManager, _TextEvent);

  function RemoveManager(opts) {
    var _this;

    _classCallCheck(this, RemoveManager);

    var EventName = opts.EventName || 'Remove';
    _this = _possibleConstructorReturn(this, _getPrototypeOf(RemoveManager).call(this, _objectSpread({
      EventName: EventName
    }, opts)));
    _this._lastSentId = null;
    _this._textManager = opts.TextManager;
    _this.action = _this.remove;
    _this._pairs = [];
    return _this;
  }
  /*!
     * \brief local deletion of a character from the sequence structure. It 
     * broadcasts the operation to the rest of the network.
     * \param index the index of the element to remove
     * \return the identifier freshly removed
     */


  _createClass(RemoveManager, [{
    key: "remove",
    value: function remove(index) {
      var lseqNode = this._sequence._get(index + 1);

      var isReady = this.getCausalID(lseqNode);
      var reference = this.removeFromSequence(index);

      this._document.delta.ops.splice(index, 1);

      debug('Remove', {
        index: index,
        reference: reference
      });

      if (reference) {
        this._sequence._c += 1;
        this.broadcast({
          id: this._document.uid,
          isReady: isReady,
          reference: reference
        });
      }

      this.setLastChangesTime();
    }
  }, {
    key: "removeFromSequence",
    value: function removeFromSequence(index) {
      if (this._sequence.root.subCounter === 2) {
        console.warn('remove from sequence is empty');
      } else if (index >= this._sequence.root.subCounter - 2) {
        console.warn('Lseq, index is out Of Bounds');
      } else {
        var reference = this._sequence.remove(index);

        return reference;
      }

      return null;
    }
    /*!
       * \brief removal of an element from a remote site.  It emits 'remoteRemove'
       * with the index of the element to remove, -1 if does not exist
       * \param id the result of the remote insert operation
       * \param origin the origin id of the removal
       */

  }, {
    key: "receive",
    value: function receive(_ref) {
      var id = _ref.id,
          reference = _ref.reference,
          isReady = _ref.isReady;
      debug('receive remove', {
        id: id,
        reference: reference
      });

      var index = this._sequence.applyRemove(reference); // this.emit('remoteRemove', index);


      this._document.delta.ops.splice(index - 1, 1);

      if (index >= 0) {
        var range = {
          index: index - 1,
          length: 0
        };
        var msg = {
          range: range,
          id: id
        };
        this.Event('Caret', msg);
      }

      this.setLastChangesTime();
    }
  }]);

  return RemoveManager;
}(TextEvent);